import { render } from "./oldIndex.vue?vue&type=template&id=a06dbb94"
import script from "./oldIndex.vue?vue&type=script&lang=js"
export * from "./oldIndex.vue?vue&type=script&lang=js"

import "./oldIndex.vue?vue&type=style&index=0&id=a06dbb94&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__